import React from 'react';
import {useSelector, useDispatch} from "react-redux";
import {get} from 'lodash';
import classNames from 'classnames';

import {FILTER_1} from "../../../../../reducers/performance_reducers";
import {
    SetDashboardFiltersAction
} from "../../../../../actions/performance_actions";
import SelectionSchool from './SelectionSchool';
import SelectionGrade from './SelectionGrade';
import SelectionTeacher from './SelectionTeacher';

export default function ({dataMode, setDataMode}) {
    const dispatch = useDispatch();

    const dashboard = useSelector(state => state.insights_dashboard);
    const dashboard_data = useSelector(state => state.dashboard_data);
    const dashboard_filters = useSelector(state => state.dashboard_filters);
    const dashboard_school_filter = useSelector(state => state.dashboard_school_filter);
    const dashboard_grade_filter = useSelector(state => state.dashboard_grade_filter);
    const dashboard_teacher_filter = useSelector(state => state.dashboard_teacher_filter);

    const filters = dashboard_filters[FILTER_1];

    // const dashboard_filter_dependencies = useSelector(state => state.dashboard_filter_dependencies);
    // console.log('dashboard_filter_dependencies', dashboard_filter_dependencies);

    const renderStudents = () => {
        const onClick = () => {
            if (dataMode !== 'student') {
                setDataMode('student');
            }
        }
        const btn_class_names = classNames(`btn`, {
            'btn-challenge': dataMode === 'student',
            'btn-flat': dataMode !== 'student',
        });
        return (
            <div className="pam-selection-left-students flex-row flex-h-end flex-v-end">
                <div className={btn_class_names} onClick={onClick}>
                    {`View Students`}
                </div>
            </div>
        );
    }

    return (
        <div className="pam-component pam-selection-part pam-selection-left flex-column flex-gap-5">
            <div className="pam-selection-left-top flex-column">
                <div className="pam-selection-header">
                    {`Schools`}
                </div>
                <SelectionSchool
                />
            </div>

            <div className="flex-auto flex-column flex-h-center">
                <div className="divider"></div>
            </div>

            <div className="pam-selection-left-bottom flex-row flex-gap-20">
                <div className="flex-3 flex-column">
                    <div className="pam-selection-header">
                        {`Grades`}
                    </div>
                    <SelectionGrade
                    />
                </div>

                <div className="flex-4 flex-column">
                    <div className="pam-selection-header">
                        {`Teachers`}
                    </div>
                    <SelectionTeacher
                    />
                </div>
            </div>

            {renderStudents()}
        </div>
    );
}
